@if (title()) {
  <div class="title px-2 m-0">{{title()}}</div>
}
<ng-content />
